import { viewerPreviewAtom } from '@/atoms/subscription.atom';
import { useFeatureFlagEnabled } from '@/lib/analytics';
import { useAtomValue } from 'jotai';

/** PostHog flag `viewerPreview`: the accounts that get the "View as Viewer" switch. */
export function useViewerPreviewAvailable(): boolean {
  return !!useFeatureFlagEnabled('viewerPreview');
}

/**
 * True while a Pro account previews the Viewer plan (GIS-438): every feature
 * gate then answers as on Viewer. Client-only — the server still allows Pro
 * work. Off whenever the flag is off, so a stored switch can't outlive it.
 */
export function useViewerPreview(): boolean {
  const on = useAtomValue(viewerPreviewAtom);
  return useViewerPreviewAvailable() && on;
}
